
import getCookie from "./getCookie";


const FileLoader = async (endpoint) => {
    let token = getCookie("auth-cookie");
    const baseURL = process.env.REACT_APP_BASEURL;
    let url = baseURL + endpoint + "/" + token;

    const response = await fetch(url, {
        method: 'POST'
    });
    if (response.ok) {

        return response.json();
    } else {

        throw new Error('Failed to fetch user data');
    }

}


export default FileLoader;